import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import AdmBuildingDropdown from "./AdmBuildingDropdown";
import MgrBuildingDropdown from "./MgrBuildingDropdown";
const BuildingsTracker = () => {
  var typeofUser = {};
  var userData = JSON.parse(sessionStorage.getItem("userdata"));
  if (userData) {
    var typeofUser = userData.data.userType;
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox bgColor="white" padding="8px">
        {typeofUser == "manager" ? (
          <MgrBuildingDropdown />
        ) : (
          <AdmBuildingDropdown />
        )}
      </MDBox>
      <br />
    </DashboardLayout>
  );
};
export default BuildingsTracker;
